"use client";
import { Typography } from "../../../components/common";
//import Animation from "../../../components/experimental/animation"
import WordMover from "../../../experimental/wordMover/WordMover";

const Playground = () => {
  return (
    <div>
      <main>
        <Typography variant="h6" className="px-4">
        Playground
        </Typography>
        {/* <Animation/> */}
        <WordMover/>
      </main>
    </div>
  );
};

export default Playground;